import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
// delon
import { AlainThemeModule } from '@delon/theme';
import { DelonABCModule } from '@delon/abc';
import { DelonACLModule } from '@delon/acl';


// #region third libs
import { NgZorroAntdModule } from 'ng-zorro-antd';
import { CountdownModule } from 'ngx-countdown';
import { CityCodeComponent } from './common/city-code/city-code.component';
import {BillDetailViewerComponent} from '../routes/customer/customer-unit/bill/bill-detail-viewer/bill-detail-viewer.component';
import {BillDetailEditorComponent} from '../routes/customer/customer-unit/bill/bill-detail-editor/bill-detail-editor.component';
import {ReviewLogComponent} from '../routes/review/review-log/review-log.component';
import {SendMessageComponent} from '../routes/customer/send-message/send-message.component';
import {ContractListComponent} from '../routes/share/contract-list/contract-list.component';
import {ContractEditorComponent} from '../routes/share/contract-editor/contract-editor.component';
import {ContractImageComponent} from '../routes/share/contract-image/contract-image.component';
const THIRDMODULES = [
  NgZorroAntdModule,
  CountdownModule
];
// #endregion

// #region your componets & directives
const COMPONENTS = [
  CityCodeComponent,
  BillDetailViewerComponent,
  BillDetailEditorComponent,
  ReviewLogComponent,
  SendMessageComponent,
  ContractListComponent,
  ContractEditorComponent,
  ContractImageComponent
];
const DIRECTIVES = [];
// #endregion

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    ReactiveFormsModule,
    AlainThemeModule.forChild(),
    DelonABCModule,
    DelonACLModule,
    // third libs
    ...THIRDMODULES
  ],
  declarations: [
    // your components
    ...COMPONENTS,
    ...DIRECTIVES,
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    AlainThemeModule,
    DelonABCModule,
    DelonACLModule,
    // third libs
    ...THIRDMODULES,
    // your components
    ...COMPONENTS,
    ...DIRECTIVES
  ],
  providers: [
  ]
})
export class SharedModule { }
